"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jquery_1 = __importDefault(require("jquery"));
function addHiddenInput(form, name, val) {
    var element = document.createElement('input');
    element.type = 'hidden';
    element.name = name;
    element.value = val;
    form.appendChild(element);
}
// eslint-disable-next-line no-underscore-dangle
window._addHiddenInput = addHiddenInput;
/* When a workflow action button is clicked, either show a modal or make a POST request to the workflow action view */
function ActivateWorkflowActionsForDashboard(csrfToken) {
    var workflowActionElements = document.querySelectorAll('[data-workflow-action-url]');
    __spreadArray([], __read(workflowActionElements)).forEach(function (buttonElement) {
        buttonElement.addEventListener('click', function (e) {
            // Stop the button from submitting the form
            e.preventDefault();
            e.stopPropagation();
            if ('launchModal' in buttonElement.dataset) {
                // eslint-disable-next-line no-undef, new-cap
                ModalWorkflow({
                    url: buttonElement.dataset.workflowActionUrl,
                    onload: {
                        action: function (modal) {
                            var nextElement = document.createElement('input');
                            nextElement.type = 'hidden';
                            nextElement.name = 'next';
                            nextElement.value = window.location;
                            jquery_1["default"]('form', modal.body).append(nextElement);
                            modal.ajaxifyForm(jquery_1["default"]('form', modal.body));
                        },
                        success: function (modal, jsonData) {
                            window.location.href = jsonData.redirect;
                        }
                    },
                });
            }
            else {
                // if not opening a modal, submit a POST request to the action url
                var formElement = document.createElement('form');
                formElement.action = buttonElement.dataset.workflowActionUrl;
                formElement.method = 'POST';
                addHiddenInput(formElement, 'csrfmiddlewaretoken', csrfToken);
                addHiddenInput(formElement, 'next', window.location);
                document.body.appendChild(formElement);
                formElement.submit();
            }
        }, { capture: true });
    });
}
window.ActivateWorkflowActionsForDashboard = ActivateWorkflowActionsForDashboard;
function ActivateWorkflowActionsForEditView(formSelector) {
    var form = jquery_1["default"](formSelector).get(0);
    var workflowActionElements = document.querySelectorAll('[data-workflow-action-name]');
    __spreadArray([], __read(workflowActionElements)).forEach(function (buttonElement) {
        buttonElement.addEventListener('click', function (e) {
            if ('workflowActionModalUrl' in buttonElement.dataset) {
                // This action requires opening a modal to collect additional data.
                // Stop the button from submitting the form
                e.preventDefault();
                e.stopPropagation();
                // open the modal at the given URL
                // eslint-disable-next-line no-undef, new-cap
                ModalWorkflow({
                    url: buttonElement.dataset.workflowActionModalUrl,
                    onload: {
                        action: function (modal) {
                            modal.ajaxifyForm(jquery_1["default"]('form', modal.body));
                        },
                        success: function (modal, jsonData) {
                            // a success response includes the additional data to submit with the edit form
                            addHiddenInput(form, 'action-workflow-action', 'true');
                            addHiddenInput(form, 'workflow-action-name', buttonElement.dataset.workflowActionName);
                            addHiddenInput(form, 'workflow-action-extra-data', JSON.stringify(jsonData.cleaned_data));
                            // note: need to submit via jQuery (as opposed to form.submit()) so that the onsubmit handler
                            // that disables the dirty-form prompt doesn't get bypassed
                            jquery_1["default"](form).submit();
                        }
                    },
                });
            }
            else {
                // no modal, so let the form submission to the edit view proceed, with additional
                // hidden inputs to tell it to perform our action
                addHiddenInput(form, 'action-workflow-action', 'true');
                addHiddenInput(form, 'workflow-action-name', buttonElement.dataset.workflowActionName);
            }
        }, { capture: true });
    });
}
window.ActivateWorkflowActionsForEditView = ActivateWorkflowActionsForEditView;
